module.exports = "<svg viewBox=\"0 0 6.1 6.1\"><path d=\"M5.7 3.1l-5.3 3V0l5.3 3.1z\"></path></svg>"